<template lang="pug">
  .set-hrs.widget.component
    bf-flex.starting-hrs
      label {{ $t('Open Hours:') }}

      span {{ $t('From') }}
      bf-input.category.opening.basic( :class='{ invalid: !valid }' )
        datetime(
          v-model='cfg.opening'
          type='time'
          use12-hour
          value-zone='UTC'
          zone='UTC'
          :placeholder='$t("Opening Time")'
          :minute-step='30'
        )

      span {{ $t("To")}}
      bf-input.category.closing.basic( :class='{ invalid: !valid }' )
        datetime(
          v-model='cfg.closing'
          type='time'
          use12-hour
          value-zone='UTC'
          zone='UTC'
          :placeholder='$t("Closing Time")'
          :minute-step='30'
        )

    .off-days
      label {{ $t("Open Day(s)")}}
      span.day
        label M
        input( type='checkbox' v-model='cfg.days.mon' checked)
      span.day
        label T
        input( type='checkbox' v-model='cfg.days.tue' checked)
      span.day
        label W
        input( type='checkbox' v-model='cfg.days.wed' checked)
      span.day
        label T
        input( type='checkbox' v-model='cfg.days.thu' checked)
      span.day
        label F
        input( type='checkbox' v-model='cfg.days.fri' checked)
      span.day
        label S
        input( type='checkbox' v-model='cfg.days.sat' checked)
      span.day
        label S
        input( type='checkbox' v-model='cfg.days.sun' checked)

    .cfg-btn
      bf-button.wide.inactive( v-if='disabled' disabled )
        template( v-slot:text ) {{$t("Set Block-Out Time within Open Hours")}}
      
      bf-button.wide(
        v-else
        @click.native='$emit( "cfg", cfg )'
      )
        template( v-slot:text ) {{$t("Set Block-Out Time within Open Hours")}}
      
</template>

<script>
  export default {
    name: 'set-hrs.widget.component',

    props: {
      initial: Object
    },

    data() {
      return {
        cfg: { days: {} },
      }
    },

    computed: {
      disabled() {
        return !( this.cfg.opening && this.cfg.closing)
      },

      valid() {
        let ot = new Date( this.cfg.opening )
        let ct = new Date( this.cfg.closing )
        return !!this.cfg.opening && !!this.cfg.closing && ot <= ct
      }
    },

    created() {
      if ( this.initial ) this.cfg = this.initial
    }
  }
</script>

<style lang="stylus" scoped>
  .set-hrs
    align-items center
    margin 24px 0
    > .bf-button
      margin-left 24px
    .bf-button.disabled
      color red
  
  .starting-hrs
    align-items center
    margin-bottom 16px
    label, span 
      font-weight bold
    label
      margin-right 16px
    span
      margin-right 8px
    .bf-input.opening
      background white
      margin-right 20px
      @media(max-width: 640px)
        width 100px
    .bf-input.closing
      background white
      @media(max-width: 640px)
        width 100px
  .bf-button.wide.inactive
    color gray
    font-size 1.1em

  .off-days
    margin-bottom 24px
    font-weight bold
    display flex
    align-items center
    > label
      margin-right 10px
    .day 
      margin 0 10px
      display flex
      align-items center
      > label
        margin-right 4px
      @media(max-width: 560px)
        margin 0 5px
</style>
